// extracted by mini-css-extract-plugin
export default {"advanceSearchBox":"AdvanceSearchLayout_advanceSearchBox__UICa9","customer-tooltip":"AdvanceSearchLayout_customer-tooltip__3Knfn","infoIcon":"AdvanceSearchLayout_infoIcon__IoWIr"};